import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
function FormFieldTemplateIsDeleted() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(Form.Item, {
        hidden: true,
        label: getFieldNameTranslated(TemplateMetaDataField.IsDeleted, t),
        extra: t("Define if this template is deleted."),
        shouldUpdate: (prev, next)=>prev.isDeleted !== next.isDeleted,
        children: ()=>{
            return /*#__PURE__*/ _jsx(Form.Item, {
                name: TemplateMetaDataField.IsDeleted,
                children: /*#__PURE__*/ _jsx(Radio.Group, {
                    options: [
                        {
                            label: t("Active"),
                            value: false
                        },
                        {
                            label: t("Deleted"),
                            value: true
                        }
                    ],
                    optionType: "button",
                    buttonStyle: "solid",
                    disabled: true
                })
            });
        }
    });
}
export { FormFieldTemplateIsDeleted };
